import { useState } from "react";
import { Search, X } from "lucide-react";

export const PickerSheet = ({ title, items, onSelect, onClose }) => {
    const [q, setQ] = useState("");
    const list = items.filter((i) => i.toLowerCase().includes(q.trim().toLowerCase()));

    return (
        <div className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center" data-testid="price-picker">
            <button type="button" aria-label="Schließen" className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-testid="price-picker-backdrop" />
            <div className="relative w-full sm:max-w-md max-h-[80vh] flex flex-col bg-[#111] border border-white/10 rounded-t-2xl sm:rounded-2xl text-white shadow-2xl animate-[fadeIn_.2s_ease-out]">
                <div className="flex items-center justify-between px-5 pt-5 pb-3">
                    <h3 className="font-body text-lg font-semibold">{title}</h3>
                    <button type="button" onClick={onClose} className="p-2 rounded-full hover:bg-white/10 transition-colors" data-testid="price-picker-close"><X size={18} /></button>
                </div>
                {items.length > 8 && (
                    <div className="mx-5 mb-3 flex items-center gap-2 rounded-xl bg-white/5 border border-white/10 px-3">
                        <Search size={16} className="text-white/50" />
                        <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Suchen…" className="w-full bg-transparent py-3 text-sm outline-none placeholder:text-white/40" data-testid="price-picker-search" />
                    </div>
                )}
                <ul className="overflow-y-auto px-3 pb-4" role="listbox">
                    {list.map((i) => (
                        <li key={i}>
                            <button type="button" onClick={() => onSelect(i)} className="w-full text-left px-3 py-3 rounded-lg text-sm hover:bg-brand/20 hover:text-white transition-colors" data-testid={`price-picker-option-${i.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                                {i}
                            </button>
                        </li>
                    ))}
                    {list.length === 0 && <li className="px-3 py-6 text-sm text-white/50" data-testid="price-picker-empty">Keine Treffer</li>}
                </ul>
            </div>
        </div>
    );
};
